import React from "react";
// import newlogo from "../Images/TALKCMO LOGO.webp";
// import newlogo from "../Images/TALKCMO LOGO.webp";
import newlogo from "../Images/footer logos/NewLogos/TCMOLogo.webp"
// import abcIT from "../Images/Itnew11.webp";
import abcIT from "../Images/footer logos/NewLogos/ITSW-logo.webp"
// import abcMartech from "../Images/abcMartech.webp";
import abcMartech from "../Images/footer logos/NewLogos/martech-logo.webp"
import abcDev from "../Images/DevNew.webp";
import abcFin from "../Images/FintechNew.webp";
import abcEt from "../Images/abcET.webp";

const logos = [


  {
    link: "https://enterprisetalk.com/",
    src: abcEt,
    alt: "enterprisetalk",
    className: "imgPublica",
  },
  {
    link: "https://itsecuritywire.com/",
    src: abcIT,
    alt: "itsecurity",
    className: "imgPublicaCMO",
  },


  {
    link: "https://talkfintech.com/",
    src: abcFin,
    alt: "talkfintech",
    className: "imgPublica",
  },



  {
    link: "https://talkmartech.com/",
    src: abcMartech,
    alt: "talkmartech",
    className: "imgPublica",
  },
  {
    link: "https://talkcmo.com/",
    src: newlogo,
    alt: "talkcmo",
    className: "imgPublica",
  },

 
];

const FootLogoComp = () => {
  return (
    <div className="footer-grid">
      {logos?.map((logo, index) => (
        <a key={index} href={logo.link} className="footer-grid-item">
          <img
            className={logo.className}
            src={logo.src}
            alt={logo.alt}
            loading="lazy"
          />
        </a>
      ))}
    </div>
  );
};

export default FootLogoComp;
